import {WidgetDefinition, Widgets} from "@/components/widgets/WidgetFather"

const widgetByNameMap: Map<string, WidgetDefinition> = new Map(parseWidgets())

function parseWidgets(): [string, any][] {
  const widgets: [string, any][] = []
  for(const category of Widgets) {
    const categoryPath = category.componentPath || null
    for(const widget of category.widgets) {
      if (categoryPath && !widget.componentPath) {
        widget.componentPath = categoryPath
      }
      widgets.push([widget.widget, widget as WidgetDefinition])
    }
  }
  return widgets
}

export function getComponentPathByName(widgetName: string): string {
  const w = widgetByNameMap.get(widgetName)
  if (w && "componentPath" in w){
    if (w.componentPath?.endsWith("/")) {
      return `${w.componentPath}${widgetName}.vue`
    } else {
      return `${w.componentPath}`
    }
  } else {
    return `${widgetName}.vue`
  }
}

export function widgetByName(name: string) {
  // require.context("@/components/widgets", true, /.*/, "sync")
  const widgetPath = getComponentPathByName(name)
  const widget = () => ({
    component: import(/* webpackPrefetch: 1 */ `@/components/widgets/${widgetPath}`),
    delay: 200,
    timeout: 5000,
  })
  return widget
}
